<div class="container">
  <div class="">
    <div class="pt-2 pb-2">
      <h1>Вход</h1>
    </div>
  </div>
</div>
<div class="container" id="tab-container">
  <div>
    <div class="row">
      <div class="col">
          <div class="form-row mb-3">
            <div class="col-auto alert alert-danger" [hidden]="status">
              Неверный логин или пароль
            </div>
            <div class="col-auto">
              <label>Имя пользователя:</label>
            </div>
            <div class="col-auto">
              <input type="text" id="login_field_id" name="username" class="form-control" tabindex="-1"
                     [(ngModel)]="user.username" #username="ngModel" required>
              <div [hidden]="username.valid || username.untouched" class="alert alert-danger">
                Не указан логин
              </div>
            </div>
          </div>
          <div class="form-row mb-3">
            <div class="col-auto">
              <label>Пароль:</label>
            </div>
            <div class="col-auto">
              <input type="password" id="password_field_id" name="password" class="form-control" tabindex="-1"
                     [(ngModel)]="user.password" #password="ngModel" required>
              <div [hidden]="password.valid || password.untouched" class="alert alert-danger">
                Не указан пароль
              </div>
            </div>
          </div>
          <div class="form-row mb-3">
            <div class="col-auto">
              <button id="login_button_id" class="btn btn-log btn-sm" (click)="login()">Войти</button>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
